import type { Fund, Benchmark, CompositeBenchmark } from 'venn-api';

export const mockBenchmarks: Benchmark[] = [
  {
    fundId: '0993d240-ed49-4172-9090-e338f4a3a664',
    type: 'INVESTMENT',
    name: 'LongName',
    portfolioId: undefined,
    primary: true,
    historical: false,
    source: 'APP',
    readOnly: false,
  },
  {
    fundId: 'a89df25e-10f0-4899-bfb5-ca1420583eb2',
    type: 'COMPOSITE',
    name: 'SimpleComposite',
    portfolioId: undefined,
    primary: false,
    historical: false,
    source: 'APP',
    readOnly: false,
  },
];

const mockCompositeBenchmark: CompositeBenchmark = {
  fundId: 'a89df25e-10f0-4899-bfb5-ca1420583eb2',
  id: 34356,
  name: 'SimpleComposite',
  ownerContextId: '4f0fd5cb-43f2-4495-8ee9-7d9b4e3769a9',
  vdparFundMetadata: [],
  children: [
    {
      annualizedOffset: 2,
      weight: 1,
      fundId: '3ce7eda3-5862-4ff7-ae5e-c050cb0367e5',
    },
  ],
};

export const mockCompositeBenchmarkState = {
  name: 'SimpleComposite',
  existingComposite: mockCompositeBenchmark,
  children: [
    {
      scalingSign: 'PLUS',
      scalingValue: '2.0',
      weight: '100.0',
      fund: {
        label: 'Industrials Investment Category (ETF)',
        type: '',
        value: '3ce7eda3-5862-4ff7-ae5e-c050cb0367e5',
        fund: {
          name: 'Industrials Investment Category (ETF)',
          id: '3ce7eda3-5862-4ff7-ae5e-c050cb0367e5',
          startRange: 913939199999,
          endRange: 1583971199999,
          investmentSource: 'VENN',
          investmentType: 'INDEX',
          live: true,
          active: true,
          benchmarks: [],
        } as unknown as Fund,
      },
    },
  ],
};
